import { ReactNode } from "react";
import { classNames } from "../Utils/classNames.ts";

export function BreakableText({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={classNames("[overflow-wrap:anywhere]", className)}>
      {children}
    </span>
  );
}
